module.exports = __webpack_public_path__ + "static/03-3273d4c775cdb0d38d3c97248fd808ea.png";